import {buildFiltersUrl, reshape_response} from "../../../../helpers/functions";
import {asignaturasApi} from "../view/asignaturas.service";


export const getAsignaturas = asignaturasApi.injectEndpoints({
    endpoints: (builder) => ({
        getAsignaturas: builder.query({
            query: ({filter_params}) => ({
                url: buildFiltersUrl("/v1/api/asignaturas/", filter_params),
                method: "GET",
            }),
            providesTags: (result) =>
                Array.isArray(result)
                    ? [
                        ...result.map(({id}) => ({
                            type: "Asignaturas",
                            id,
                        })),
                        {type: "Asignaturas", id: "LIST"},
                    ]
                    : [{type: "Asignaturas", id: "LIST"}],
            transformResponse: (response, meta, args) => {
                if (Array.isArray(response)) {
                    return response?.map((el) => reshape_response(el, args.shape));
                } else {
                    const resultsTransformed = response?.results?.map((el) =>
                        reshape_response(el, args.shape)
                    );
                    return {
                        results: resultsTransformed,
                        count: response.count,
                        next: response.next,
                        previous: response.previous,
                    };
                }
            },
        }),
    }),
})

export const {
    useGetAsignaturasQuery,
} = getAsignaturas;